import { render, staticRenderFns } from "./profiledropdown.vue?vue&type=template&id=a304f7b4"
import script from "./profiledropdown.vue?vue&type=script&lang=js"
export * from "./profiledropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports